var React = require('react');

var Tabs = require('react-bootstrap/lib/Tabs');
var Tab = require('react-bootstrap/lib/Tab');

var Open = require('./Open');
var List = require('./List');
var Admin = require('./Admin');

var Requests = React.createClass({

	componentWillMount: function() {
		this.props.load();	
	},

	componentWillUnmount: function() {
		this.props.unload();
	},

	filter(filterType) {
		var me = this, type;

		if (filterType === 2)
			type = 'list';
		else
			type = 'open';

		me.props.filter(type);
	},

	render: function() {
		var me = this;

		return (
			<Tabs 
				onSelect={me.filter}
				animation={false}
				defaultActiveKey={1} 
				id="requests_filters">
				
				<Tab eventKey={1} title="Abertos">
					<Open data={me.props.requests} />
				</Tab>
				<Tab eventKey={2} title="Encerrados">
					<List data={me.props.requests} />
				</Tab>
				<Tab eventKey={3} title="Funções Admin">
					<Admin data={me.props.requests} />
				</Tab>
			</Tabs>
		);
	}

});

module.exports = Requests;


// WEBPACK FOOTER //
// ./src/components/Admin/Requests/Requests.jsx